module.exports = __webpack_public_path__ + "img/danger.1b0e3eac.svg";